const quickLinks = [
  { label: "今日热度榜", href: "#hot" },
  { label: "本周精选", href: "#weekly" },
  { label: "按栏目翻瓜田", href: "#category" },
  { label: "新鲜速递", href: "#fresh" },
  { label: "深度专栏", href: "#column" },
  { label: "吃瓜小课堂", href: "#faq" },
];

const columnLinks = ["影视", "综艺", "音乐", "生活", "演出", "人物"];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-news-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-foreground-950">每日瓜料</span>
                <span className="text-[10px] tracking-widest text-foreground-500">热门瓜 · 一页看全</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              把一周热门瓜料与近期新瓜集中到一页，按热度归档、逐条标注来源，
              让每个吃瓜群众都能省下到处翻找的时间。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-500/10 px-2.5 py-1 text-accent-700">
                <i className="ri-shield-check-line" aria-hidden="true"></i> 先核实，再吃瓜
              </span>
            </div>
          </div>

          <nav aria-label="快速导航">
            <h4 className="text-sm font-semibold text-foreground-950">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="栏目导航">
            <h4 className="text-sm font-semibold text-foreground-950">栏目直达</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {columnLinks.map((c) => (
                <li key={c}>
                  <a
                    href="#category"
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {c}热瓜
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">订阅与联系</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              订阅瓜料日报，热门瓜每日准时送到。
            </p>
            <a
              href="#subscribe"
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              <i className="ri-mail-add-line" aria-hidden="true"></i>
              立即订阅
            </a>
            <a
              href="mailto:tougao@meirigualliao.example"
              className="mt-3 inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600"
            >
              <i className="ri-quill-pen-line" aria-hidden="true"></i>
              吃瓜投稿 / 线索
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-center sm:flex-row sm:text-left md:px-6">
          <p className="text-xs text-foreground-500">
            © 2026 每日瓜料 · 本文内容均为娱乐资讯化名演示素材
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#about" className="transition-colors hover:text-primary-600">关于我们</a>
            <a href="#faq" className="transition-colors hover:text-primary-600">常见问题</a>
            <a href="#subscribe" className="transition-colors hover:text-primary-600">订阅日报</a>
          </div>
        </div>
      </div>
    </footer>
  );
}